<template>
  <div class="service">
    <Loading v-if="serviceLoading" />
    <template v-else>
      <div class="service__title">
        <div class="service__name">{{ service.name }} </div>
        <div class="icon icon__delete" @click="removeService()"></div>
      </div>

      <div v-if="!dropdownModels.length">
        <div class="service__fields number-status-fields" v-if="isSharedInputOwner && singletonModelIndex !== null">
          <div class="service__field">
            <input type="text" class="input input--default input--shadow"
              :placeholder="$t(`addPolicyModal.${'policyNumber'}`)" :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_number : ''
                " @input="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'policy_number',
                    data: $event.target.value,
                  })
                  " />
          </div>
          <div class="service__field">
            <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
              class="select select--default select--shadow" :placeholder="$t(`addPolicyModal.${'status'}`)" :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_status_id : null
                " @update:modelValue="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'policy_status_id',
                    data: $event,
                  });
                " :class="{
                  'input--error':
                    singletonFormModels[singletonModelIndex] &&
                    singletonFormModels[singletonModelIndex].policy_statusHasError
                }" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].policy_statusHasError">
              {{ $t(`addPolicyModal.${'statusMsg'}`) }}
            </div>
          </div>
          <div class="service__field" v-if="
            singletonFormModels[singletonModelIndex] &&
            singletonFormModels[singletonModelIndex].policy_status_id == 1
          ">
            <Datepicker class="input input--default input--shadow"
              :placeholder="$t(`addPolicyModal.${'submissionDate'}`)" :config="statics.datePickerConfig"
              :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].submit_date : null"
              @change="
                handleDateInput($event, singletonModelIndex, 'submit_date', 'singletonModel');
              $store.commit('setSpecificSingletonFormModel', {
                index: singletonModelIndex,
                key: 'submit_dateHasError',
                data: false
              });
              "
              :class="{ 'input--error': singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError }" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError">
              {{ $t(`addPolicyModal.${'submissionErrorMsg'}`) }}
            </div>
          </div>
        </div>

        <div class="service_fields non-kvg">
          <div class="service__field">
            <Datepicker class="input input--default input--shadow" :class="{
              'input--error':
                singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].startDateHasError,
            }" :placeholder="$t(`addPolicyModal.${'startDate'}`)" :config="statics.datePickerConfig"
              :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].startDate : null"
              @change="
                handleDateInput($event, singletonModelIndex, 'startDate', 'singletonModel');
              $store.commit('setSpecificSingletonFormModel', {
                index: singletonModelIndex,
                key: 'startDateHasError',
                data: false
              });
              "
              @blur="handleDateBlur($event, singletonModelIndex, 'startDate', 'singletonModel')" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].startDateHasError">
              {{ $t(`addPolicyModal.${'invalidDate'}`) }}
            </div>
          </div>
          <template v-if="service.code != 'MM'">
            <div class="service__field">
              <Datepicker ref="singletonEndDateRef" class="input input--default input--shadow"
                :placeholder="$t(`addPolicyModal.${'endDate'}`)" :config="statics.datePickerConfig"
                :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].endDate : null"
                @change="handleDateInput($event, singletonModelIndex, 'endDate', 'singletonModel')" />
            </div>
            <div class="service__field">
              <input type="text" class="input input--default input--shadow" :class="{
                'input--error':
                  singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].priceHasError,
              }" :placeholder="$t(`addPolicyModal.${'price'}`)" @input="
                $store.commit('setSpecificSingletonFormModel', {
                  index: singletonModelIndex,
                  key: 'price',
                  data: $event.target.value,
                })
                " />
              <div class="form__error"
                v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].priceHasError">
                {{ $t(`addPolicyModal.${'invalidPriceValue'}`) }}
              </div>
            </div>
            <div class="service__field">
              <VSelect class="select select--default select--shadow" :options="intervals"
                :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                :placeholder="intervals[3].name" @update:modelValue="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'interval',
                    data: $event,
                  })
                  " />
            </div>
            <div class="service__field" v-if="service.id == 11">
              <input type="text" class="input input--default input--shadow"
                :placeholder="$t(`addCompanyContactModal.${'mark'}`)" @input="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'plateNumber',
                    data: $event.target.value,
                  })
                  " />
            </div>
          </template>
        </div>
      </div>

      <template v-else>
        <template v-if="service.id !== KVG">
          <div class="policy__service-toggler">
            <span>{{ $t(`addPolicyModal.${'models'}`) }}</span>
            <div class="policy__service-adder" :class="{
              'policy__service-adder--active': showModelsDropdown,
            }" @click="showModelsDropdown = !showModelsDropdown"></div>

            <transition name="fade">
              <div class="service-dropdown" v-if="showModelsDropdown">
                <div class="service-dropdown__content">
                  <div class="service-dropdown__title">
                    {{ $t(`addPolicyModal.${'chooseModels'}`) }}
                  </div>

                  <div class="service-dropdown__body">
                    <div v-if="!dropdownModels.length" class="service-dropdown__no-data">
                      {{ $t(`addPolicyModal.${'noModelsFound'}`) }}
                    </div>

                    <template v-else>
                      <div class="service-dropdown__item" v-for="model in dropdownModels" :key="model.id">
                        <div class="checkbox">
                          <input type="checkbox" class="checkbox__checkbox"
                            :checked="models.some((m) => m.id === model.id)" :id="model.id"
                            @input="addOrRemoveModels($event, model)" />

                          <label :for="model.id" class="checkbox__label checkbox__label--smaller"></label>
                        </div>
                        <label :for="model.id" class="service-dropdown__item-title">
                          {{ model.name }}
                        </label>
                      </div>
                    </template>
                  </div>

                  <div class="service-dropdown__buttons">
                    <button type="button" class="service-dropdown__button service-dropdown__button--submit"
                      @click="applyModels()"></button>
                    <button type="button" class="service-dropdown__button service-dropdown__button--cancel"
                      @click="showModelsDropdown = false"></button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </template>

        <template v-else>
          <div class="model">
            <div class="service__fields number-status-fields"
              v-if="isSharedInputOwner && (service.id === KVG || singletonModelIndex !== null)">

              <div class="service__field">
                <input type="text" class="input input--default input--shadow"
                  :placeholder="$t(`addPolicyModal.${'policyNumber'}`)"
                  :value="service.id === KVG ? singleModel.policy_number : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_number : '')"
                  @input="
                    service.id === KVG
                      ? $store.commit('setSpecificSingleModel', { key: 'policy_number', data: $event.target.value })
                      : $store.commit('setSpecificSingletonFormModel', { index: singletonModelIndex, key: 'policy_number', data: $event.target.value })
                    " />
              </div>

              <div class="service__field">
                <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
                  class="select select--default select--shadow" :placeholder="$t(`addPolicyModal.${'status'}`)"
                  :value="service.id === KVG ? singleModel.policy_status_id : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_status_id : null)"
                  @update:modelValue="
                    service.id === KVG
                      ? (
                        $store.commit('setSpecificSingleModel', {
                          key: 'policy_status_id',
                          data: $event
                        }),
                        $store.commit('setSpecificSingleModel', {
                          key: 'submit_dateHasError',
                          data: false
                        })
                      )
                      : $store.commit('setSpecificSingletonFormModel', {
                        index: singletonModelIndex,
                        key: 'policy_status_id',
                        data: $event
                      })
                    " :class="{
                      'input--error': service.id === KVG ? singleModel.policy_statusHasError : (singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].policy_statusHasError)
                    }" />
              </div>

              <div class="service__field" v-if="(service.id === KVG
                ? singleModel.policy_status_id
                : (singletonFormModels[singletonModelIndex]
                  ? singletonFormModels[singletonModelIndex].policy_status_id
                  : null)) == 1">

                <Datepicker class="input input--default input--shadow"
                  :placeholder="$t(`addPolicyModal.${'submissionDate'}`)" :class="{
                    'input--error': service.id === KVG
                      ? singleModel.submit_dateHasError
                      : (singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError)
                  }" :value="service.id === KVG ? formatDisplayDate(singleModel.submit_date) : formatDisplayDate(singletonFormModels[singletonModelIndex]?.submit_date)
                    " @change="
                    service.id === KVG
                      ? (
                        handleDateInput($event, null, 'submit_date', 'singleModel'),
                        $store.commit('setSpecificSingleModel', {
                          key: 'submit_dateHasError',
                          data: false
                        })
                      )
                      : (
                        handleDateInput($event, singletonModelIndex, 'submit_date', 'singletonModel'),
                        $store.commit('setSpecificSingletonFormModel', {
                          index: singletonModelIndex,
                          key: 'submit_dateHasError',
                          data: false
                        })
                      )
                    " />

                <div class="form__error"
                  v-if="service.id === KVG
                    ? singleModel.submit_dateHasError
                    : (singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError)">
                  {{ $t(`addPolicyModal.${'submissionErrorMsg'}`) }}
                </div>

              </div>
            </div>

            <div class="model__field">
              <VSelect class="select select--default select--model-dropdown select--shadow" :options="dropdownModels"
                :reduce="(model) => model.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                :value="singleModel.id" @update:modelValue="
                  $store.commit('setSpecificSingleModel', {
                    key: 'id',
                    data: $event,
                  })
                  " />
            </div>
            <div class="model__fields">
              <div class="model__field">
                <Datepicker class="input input--default input--shadow"
                  :class="{ 'input--error': singleModel && singleModel.startDateHasError }"
                  :placeholder="$t(`addPolicyModal.${'startDate'}`)" :config="statics.datePickerConfig"
                  :value="singleModel ? singleModel.startDate : null"
                  @change="handleDateInput($event, null, 'startDate', 'singleModel')"
                  @blur="handleDateBlur($event, null, 'startDate', 'singleModel')" />
                <div class="form__error" v-if="singleModel && singleModel.startDateHasError">
                  {{ $t(`addPolicyModal.${'invalidDate'}`) }}
                </div>
              </div>
              <div class="model__field">
                <Datepicker ref="singleModelEndDateRef" class="input input--default input--shadow"
                  :placeholder="$t(`addPolicyModal.${'endDate'}`)" :config="statics.datePickerConfig"
                  :value="singleModel ? singleModel.endDate : null"
                  @change="handleDateInput($event, null, 'endDate', 'singleModel')" />
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="dropdownFranchises"
                  :reduce="(franchise) => franchise.id" label="franchise" :appendToBody="true"
                  :calculatePosition="withPopper" :placeholder="$t(`addPolicyModal.${'franchise'}`)"
                  :disabled="!isSingleModelStartDateValid" :modelValue="singleModel.franchise" @update:modelValue="
                    $store.commit('setSpecificSingleModel', {
                      key: 'franchise',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="accidents"
                  :reduce="(accident) => accident.value" label="title" :appendToBody="true"
                  :calculatePosition="withPopper" :placeholder="$t(`addPolicyModal.${'accident'}`)" @update:modelValue="
                    $store.commit('setSpecificSingleModel', {
                      key: 'accident',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow"
                  :placeholder="$t(`addPolicyModal.${'doctorName'}`)" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'doctorName',
                      data: $event.target.value,
                    })
                    " />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow"
                  :class="{ 'input--error': singleModel.priceHasError }" :placeholder="$t(`addPolicyModal.${'price'}`)"
                  @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'price',
                      data: $event.target.value,
                    })
                    " />
                <div class="form__error" v-if="singleModel.priceHasError">
                  {{ $t(`addPolicyModal.${'invalidPriceValue'}`) }}
                </div>
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="intervals"
                  :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  :placeholder="intervals[3].name" @update:modelValue="
                    $store.commit('setSpecificSingleModel', {
                      key: 'interval',
                      data: $event,
                    })
                    " />
              </div>
            </div>
          </div>
        </template>

        <div class="models">
          <div class="model model--multiple" v-for="(model, index) in models" :key="model.id">
            <div class="model__name">{{ model.name }}</div>
            <div class="service__fields number-status-fields" v-if="isSharedInputOwner">
              <div class="service__field">
                <input type="text" class="input input--default input--shadow"
                  :placeholder="$t(`addPolicyModal.${'policyNumber'}`)"
                  :value="formModels[index] ? formModels[index].policy_number : ''" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'policy_number',
                      data: $event.target.value,
                    })
                    " />
              </div>
              <div class="service__field">
                <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
                  class="select select--default select--shadow" :placeholder="$t(`addPolicyModal.${'status'}`)"
                  :value="formModels[index] ? formModels[index].policy_status_id : null" @update:modelValue="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'policy_status_id',
                      data: $event,
                    });
                  " :class="{ 'input--error': formModels[index] && formModels[index].policy_statusHasError }" />
                <div class="form__error" v-if="formModels[index] && formModels[index].policy_statusHasError">
                  {{ $t(`addPolicyModal.${'statusMsg'}`) }}
                </div>
              </div>
              <div class="service__field" v-if="formModels[index] && formModels[index].policy_status_id == 1">
                <Datepicker class="input input--default input--shadow"
                  :placeholder="$t(`addPolicyModal.${'submissionDate'}`)" :config="statics.datePickerConfig"
                  :value="formModels[index] ? formModels[index].submit_date : null"
                  @change="handleDateInput($event, index, 'submit_date', 'formModel'); $store.commit('setSpecificFormModel', { index, key: 'submit_dateHasError', data: false });"
                  :class="{ 'input--error': formModels[index] && formModels[index].submit_dateHasError }" />
                <div class="form__error" v-if="formModels[index] && formModels[index].submit_dateHasError">
                  {{ $t(`addPolicyModal.${'submissionErrorMsg'}`) }}
                </div>
              </div>
            </div>

            <div class="model__fields">
              <div class="model__field">
                <Datepicker class="input input--default input--shadow" :class="{
                  'input--error': formModels[index] && formModels[index].startDateHasError,
                }" :placeholder="$t(`addPolicyModal.${'startDate'}`)" :config="statics.datePickerConfig"
                  :value="formModels[index] ? formModels[index].startDate : null"
                  @change="handleDateInput($event, index, 'startDate', 'formModel')"
                  @blur="handleDateBlur($event, index, 'startDate', 'formModel')" />
                <div class="form__error" v-if="formModels[index] && formModels[index].startDateHasError">
                  {{ $t(`addPolicyModal.${'invalidDate'}`) }}
                </div>
              </div>
              <div class="model__field">
                <Datepicker ref="formModelsEndDateRefs" class="input input--default input--shadow"
                  :placeholder="$t(`addPolicyModal.${'endDate'}`)" :config="statics.datePickerConfig"
                  :value="formModels[index] ? formModels[index].endDate : null"
                  @change="handleDateInput($event, index, 'endDate', 'formModel')" />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow"
                  :class="{ 'input--error': formModels[index] && formModels[index].priceHasError }"
                  :placeholder="$t(`addPolicyModal.${'price'}`)" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'price',
                      data: $event.target.value,
                    })
                    " />
                <div class="form__error" v-if="formModels[index] && formModels[index].priceHasError">
                  {{ $t(`addPolicyModal.${'invalidPriceValue'}`) }}
                </div>
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="intervals"
                  :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  :placeholder="intervals[3].name" @update:modelValue="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'interval',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field model__field--economy"
                v-if="model && model.model_categories && model.model_categories.length">
                <VSelect class="select select--default select--shadow" :options="model.model_categories"
                  :reduce="(category) => category.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  placeholder="Economy" @update:modelValue="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'economy',
                      data: $event,
                    })
                    " />
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import statics from "@/statics";
import { parseBirthday } from "@/helpers/entityParsers";

import withPopper from "@/helpers/withPopper";
import moment from "moment";

const formatDisplayDate = (date) => {
  if (!date) return null;

  return moment(date, ["YYYY-MM-DD", "DD.MM.YYYY"], true).isValid()
    ? moment(date, ["YYYY-MM-DD", "DD.MM.YYYY"]).format("DD.MM.YYYY")
    : date;
};

defineOptions({
  name: "Service"
});

const props = defineProps({
  service: {
    required: true,
    type: Object,
  },
  companyId: {
    required: true,
    type: Number,
  },
  deleteService: {
    required: true,
    type: Function,
  },
  servicesToDelete: {
    required: true,
    type: Array,
  },
  options: {
    required: false,
    type: Array,
  },
  serviceSelectionOrder: {
    required: false,
    type: Array,
    default: () => [],
  },
  allSelectedServices: {
    required: false,
    type: Array,
    default: () => [],
  },
});

const store = useStore();
 
const extractDateValue = (value) => { 
  if (value instanceof Event) {
    const inputValue = value.target?.value;
    if (inputValue) return inputValue;
    return null;
  }
 
  if (!value) return null;
 
  if (Array.isArray(value)) {
    const firstElement = value.length > 0 ? value[0] : null;
    if (firstElement instanceof Event) {
      const inputValue = firstElement.target?.value;
      if (inputValue) return inputValue;
      return null;
    }
    return firstElement;
  }
 
  return value;
};
 
const calculateYearEndDate = (startDate) => {
  if (!startDate) return null;
 
  const parsedDate = moment(startDate, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
  if (!parsedDate.isValid()) return null;
 
  const endDate = parsedDate.clone().endOf('year'); 
  return endDate.format("YYYY-MM-DD");
};

const shouldAutoPopulateEndDate = (model, previousStartDate = null) => {
  if (!model || props.service.id !== KVG) return false;
  if (!model.startDate) return false;

  if (!model.endDate) return true;
  if (!previousStartDate) return false;

  return model.endDate === calculateYearEndDate(previousStartDate);
};

const applyAutoEndDate = (modelType, index, model, previousStartDate = null) => {
  if (!shouldAutoPopulateEndDate(model, previousStartDate)) return;

  const endDate = calculateYearEndDate(model.startDate);
  if (!endDate) return;

  if (modelType === 'formModel') {
    store.commit('setSpecificFormModel', { index, key: 'endDate', data: endDate });
    if (formModelsEndDateRefs.value[index]?.fp) {
      const parsedDate = moment(endDate, 'YYYY-MM-DD', true);
      formModelsEndDateRefs.value[index].fp.setDate(parsedDate.toDate(), false);
    }
  } else if (modelType === 'singletonModel') {
    store.commit('setSpecificSingletonFormModel', { index, key: 'endDate', data: endDate });
    if (singletonEndDateRef.value?.fp) {
      const parsedDate = moment(endDate, 'YYYY-MM-DD', true);
      singletonEndDateRef.value.fp.setDate(parsedDate.toDate(), false);
    }
  } else if (modelType === 'singleModel') {
    store.commit('setSpecificSingleModel', { key: 'endDate', data: endDate });
    store.commit('setSpecificSingleModel', { key: 'franchise', data: '' });
    if (singleModelEndDateRef.value?.fp) {
      const parsedDate = moment(endDate, 'YYYY-MM-DD', true);
      singleModelEndDateRef.value.fp.setDate(parsedDate.toDate(), false);
    }
  }
};
 
const handleDateInput = (value, index, key, modelType = 'formModel') => {
  const dateValue = extractDateValue(value);
  const previousStartDate = modelType === 'formModel'
    ? formModels.value[index]?.startDate
    : modelType === 'singletonModel'
      ? singletonFormModels.value[index]?.startDate
      : singleModel.value?.startDate;

  if (modelType === 'formModel') {
    store.commit('setSpecificFormModel', { index, key, data: dateValue });
  } else if (modelType === 'singletonModel') {
    store.commit('setSpecificSingletonFormModel', { index, key, data: dateValue });
  } else if (modelType === 'singleModel') {
    store.commit('setSpecificSingleModel', { key, data: dateValue });
  }

  if (key === 'startDate' && dateValue) {
    const nextModel = modelType === 'formModel'
      ? { ...(formModels.value[index] || {}), startDate: dateValue }
      : modelType === 'singletonModel'
        ? { ...(singletonFormModels.value[index] || {}), startDate: dateValue }
        : { ...(singleModel.value || {}), startDate: dateValue };

    applyAutoEndDate(modelType, index, nextModel, previousStartDate);
  }
};

const handleDateBlur = (value, index, key, modelType = 'formModel') => {
  if (!value) return;
  handleDateInput(value, index, key, modelType);
};

// State
const KVG = statics.KVG;
const maxUnderAgedIdFranchise = 7;
const teenage = 18;
const serviceLoading = ref(false);
const showModelsDropdown = ref(false);
const dropdownModels = ref([]);
const preModels = ref([]);
const models = ref([]);
const singletonModelIndex = ref(null);
 
const singletonEndDateRef = ref(null);
const singleModelEndDateRef = ref(null);
const formModelsEndDateRefs = ref([]);

// Computed 
const policyForms = computed(() => store.getters.policyForms);
const customerDetails = computed(() => store.getters.customerDetails);
const formModels = computed(() => store.getters.formModels);
const singleModel = computed(() => store.getters.singleModel);
const singletonFormModels = computed(() => store.getters.singletonFormModels);
const servicesToRemove = computed(() => store.getters.servicesToRemove);

// Determine if this service and KVG/VVG pair should share Policy Number/Status inputs
// Sharing ONLY happens when BOTH KVG and VVG services are selected together
const shouldShareInputs = computed(() => {
  // Check if both KVG and VVG services exist in selected services
  const kvgService = props.allSelectedServices.find(s => s.code?.toLowerCase() === 'kvg');
  const vvgService = props.allSelectedServices.find(s => s.code?.toLowerCase() === 'vvg');
  const isCurrentServiceSingleton = dropdownModels.value.length === 0;
  
  // Sharing requires: BOTH KVG and VVG selected AND current service is a singleton
  if (!kvgService || !vvgService || !isCurrentServiceSingleton) {
    return false;
  }
  
  // Current service must be either KVG or VVG for sharing to apply
  const currentCode = props.service.code?.toLowerCase();
  return currentCode === 'kvg' || currentCode === 'vvg';
});

// Determine if this service owns/displays the shared Policy Number/Status inputs
const isSharedInputOwner = computed(() => {
  if (!shouldShareInputs.value) {
    // Not in a sharing scenario: this service always displays its own inputs
    return true;
  }
  
  // In a sharing scenario (KVG + VVG both selected):
  // Only the first-selected service displays the inputs
  const firstSelectedId = props.serviceSelectionOrder[0];
  return props.service.id === firstSelectedId;
});

const intervals = computed(() => policyForms.value.intervals);
const accidents = computed(() => [
  { title: "Yes", value: true },
  { title: "No", value: false },
]);
const franchises = computed(() => policyForms.value.franchises);
const underAgedFranchises = computed(() => franchises.value.filter((f) => f.id <= maxUnderAgedIdFranchise));
const agedFranchises = computed(() => franchises.value.filter((f) => f.id > maxUnderAgedIdFranchise));
 
const isSingleModelStartDateValid = computed(() => {
  const startDate = singleModel.value?.startDate;
  if (!startDate) return false;
  const parsed = moment(startDate, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
  return parsed.isValid();
});
 
const dropdownFranchises = computed(() => {
  const currentAge = parseBirthday(customerDetails.value.birthday);
 
  if (currentAge > teenage) {
    return agedFranchises.value;
  }
 
  if (currentAge < teenage) {
    return underAgedFranchises.value;
  }
 
  if (currentAge === teenage) { 
    let startDate = null;
    let endDate = null;

    if (singleModel.value?.startDate) {
      startDate = moment(singleModel.value.startDate, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
      endDate = moment(singleModel.value.endDate, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
    } else if (singletonFormModels.value[singletonModelIndex.value]) {
      const model = singletonFormModels.value[singletonModelIndex.value];
      startDate = moment(model.startDate, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
      endDate = moment(model.endDate, ["YYYY-MM-DD", "DD.MM.YYYY"], true);
    }
 
    if (startDate && startDate.isValid() && endDate && endDate.isValid()) {
      const customerBirthday = moment(customerDetails.value.birthday, "YYYY-MM-DD");
 
      let upcomingBirthday = customerBirthday.clone().year(new Date().getFullYear());
      if (upcomingBirthday.isBefore(moment())) {
        upcomingBirthday = customerBirthday.clone().year(new Date().getFullYear() + 1);
      }
 
      if (upcomingBirthday.isBetween(startDate, endDate, null, '[]')) {
        return agedFranchises.value;
      }
    }
 
    return underAgedFranchises.value;
  }

  return underAgedFranchises.value;
});

// Watcher
watch(() => props.servicesToDelete, (services) => {
  if (services.length) {
    const serviceToDelete = services.find((s) => s.id === props.service.id);
    if (serviceToDelete && !servicesToRemove.value.some((s) => s.id === serviceToDelete.id)) {
      const { id } = serviceToDelete;
      let type = id === KVG ? "KVG" : (dropdownModels.value.length ? "multiple" : "singleton");
      store.commit("setServicesToRemove", [...servicesToRemove.value, { id, type }]);
    }
  }
});
 
watch(() => singleModel.value?.startDate, (newStartDate, previousStartDate) => {
  if (!newStartDate || singleModel.value?.serviceId !== props.service.id) return;

  if (shouldAutoPopulateEndDate(singleModel.value, previousStartDate)) {
    const endDate = calculateYearEndDate(newStartDate);
    if (endDate) {
      store.commit('setSpecificSingleModel', {
        key: 'endDate',
        data: endDate,
      });
      store.commit('setSpecificSingleModel', {
        key: 'franchise',
        data: '',
      });
      if (singleModelEndDateRef.value?.fp) {
        const parsedDate = moment(endDate, "YYYY-MM-DD", true);
        singleModelEndDateRef.value.fp.setDate(parsedDate.toDate(), false);
      }
    }
  }
});
 
watch(() => singleModel.value?.endDate, () => {
  if (singleModel.value?.franchise) {
    store.commit('setSpecificSingleModel', {
      key: 'franchise',
      data: '',
    });
  }
});
 
watch(() => singletonFormModels.value, (models) => {
  models.forEach((model, index) => {
    if (model && model.serviceId === props.service.id && shouldAutoPopulateEndDate(model)) {
      const endDate = calculateYearEndDate(model.startDate);
      if (endDate) {
        store.commit('setSpecificSingletonFormModel', {
          index,
          key: 'endDate',
          data: endDate,
        });
        if (singletonEndDateRef.value?.fp) {
          const parsedDate = moment(endDate, "YYYY-MM-DD", true);
          singletonEndDateRef.value.fp.setDate(parsedDate.toDate(), false);
        }
      }
    }
  });
}, { deep: true });
 
watch(() => formModels.value, (models) => {
  models.forEach((model, index) => {
    if (model && model.serviceId === props.service.id && shouldAutoPopulateEndDate(model)) {
      const endDate = calculateYearEndDate(model.startDate);
      if (endDate) {
        store.commit('setSpecificFormModel', {
          index,
          key: 'endDate',
          data: endDate,
        });
        if (formModelsEndDateRefs.value[index]?.fp) {
          const parsedDate = moment(endDate, "YYYY-MM-DD", true);
          formModelsEndDateRefs.value[index].fp.setDate(parsedDate.toDate(), false);
        }
      }
    }
  });
}, { deep: true });

// Lifecycle / Methods
onMounted(async () => {
  serviceLoading.value = true;
  dropdownModels.value = await store.dispatch("getModelsByCompanyServiceAndCustomer", {
    serviceId: props.service.id,
    companyId: props.companyId,
    customerId: customerDetails.value.id,
  });

  const isKVG = props.service.id === KVG;
  const hasNoModels = dropdownModels.value.length === 0;

  if (isKVG && !hasNoModels) {
    store.commit("setSingleModel", { ...singleModel.value, id: dropdownModels.value[0].id, serviceId: props.service.id, branch_category_id: props.service.branch_category_id, policy_statusHasError: false });
  } else if (hasNoModels) {
    const newSingleton = { serviceId: props.service.id, branch_category_id: props.service.branch_category_id, policy_number: "", policy_status_id: "", policy_statusHasError: false, submit_date: null, submit_dateHasError: false, startDate: "", endDate: null, price: "", startDateHasError: false, priceHasError: false };
    if (singletonFormModels.value.findIndex(m => m.serviceId === props.service.id) === -1) {
      store.commit("setSingletonFormModels", [...singletonFormModels.value, newSingleton]);
    }
    if (isKVG) store.commit("setSingleModel", { id: "", serviceId: "" });
  }

  const finalIndex = singletonFormModels.value.findIndex(m => m.serviceId === props.service.id);
  singletonModelIndex.value = finalIndex !== -1 ? finalIndex : null;
  serviceLoading.value = false;
});

const addOrRemoveModels = (event, model) => {
  const { checked } = event.target;
  const idx = preModels.value.findIndex((m) => m.id === model.id);
  if (checked && idx === -1) {
    preModels.value = [...preModels.value, model];
    if (!formModels.value.some((m) => m.id === model.id)) {
      const master = [singleModel.value, ...formModels.value, ...singletonFormModels.value].find(m => m && m.branch_category_id === props.service.branch_category_id && m.policy_status_id);
      store.commit("setFormModels", [...formModels.value, { id: model.id, serviceId: props.service.id, branch_category_id: props.service.branch_category_id, policy_number: master?.policy_number || "", policy_status_id: master?.policy_status_id || "", submit_date: master?.submit_date || null, policy_statusHasError: false, submit_dateHasError: false, startDate: "", endDate: null, startDateHasError: false, priceHasError: false }]);
    }
  } else {
    preModels.value.splice(idx, 1);
  }
};

const applyModels = () => {
  models.value = [...preModels.value];
  const formModelIds = models.value.map((m) => m.id);
  store.commit("setFormModels", formModels.value.filter((m) => formModelIds.includes(m.id)));
  showModelsDropdown.value = false;
};

const removeService = () => { 
  // Handle inheritance of shared inputs when removing the owner
  const kvgService = props.allSelectedServices.find(s => s.id === KVG);
  const isCurrentServiceKVG = props.service.id === KVG;
  
  // If this service owns the shared inputs and both services are selected
  if (isSharedInputOwner.value && kvgService && props.allSelectedServices.length === 2) {
    // Get the Policy Number and Status from the current service
    let policyNumber = '';
    let policyStatus = '';
    let submitDate = '';
    
    if (isCurrentServiceKVG && singleModel.value) {
      policyNumber = singleModel.value.policy_number || '';
      policyStatus = singleModel.value.policy_status_id || '';
      submitDate = singleModel.value.submit_date || '';
    } else if (!isCurrentServiceKVG && singletonModelIndex.value !== null && singletonFormModels.value[singletonModelIndex.value]) {
      policyNumber = singletonFormModels.value[singletonModelIndex.value].policy_number || '';
      policyStatus = singletonFormModels.value[singletonModelIndex.value].policy_status_id || '';
      submitDate = singletonFormModels.value[singletonModelIndex.value].submit_date || '';
    }
    
    // Transfer ownership to the remaining service
    const remainingService = props.allSelectedServices.find(s => s.id !== props.service.id);
    if (remainingService) {
      if (remainingService.id === KVG) {
        // Transfer to KVG's singleModel
        store.commit('setSpecificSingleModel', { key: 'policy_number', data: policyNumber });
        store.commit('setSpecificSingleModel', { key: 'policy_status_id', data: policyStatus });
        if (policyStatus === 1) {
          store.commit('setSpecificSingleModel', { key: 'submit_date', data: submitDate });
        }
      } else {
        // Transfer to another service's singleton
        const otherSingletonIdx = singletonFormModels.value.findIndex(m => m.serviceId === remainingService.id);
        if (otherSingletonIdx !== -1) {
          store.commit('setSpecificSingletonFormModel', { index: otherSingletonIdx, key: 'policy_number', data: policyNumber });
          store.commit('setSpecificSingletonFormModel', { index: otherSingletonIdx, key: 'policy_status_id', data: policyStatus });
          if (policyStatus === 1) {
            store.commit('setSpecificSingletonFormModel', { index: otherSingletonIdx, key: 'submit_date', data: submitDate });
          }
        }
      }
    }
  }
  
  if (props.service.id === KVG) {
    store.commit("setSingleModel", { id: "", serviceId: "" });
  } else if (!dropdownModels.value.length) { 
    const idx = singletonFormModels.value.findIndex(m => m.serviceId === props.service.id);
    if (idx !== -1) {
      const singletonModels = [...singletonFormModels.value];
      singletonModels.splice(idx, 1);
      store.commit("setSingletonFormModels", singletonModels);
    }
  } else { 
    const filteredModels = formModels.value.filter(m => m.serviceId !== props.service.id);
    store.commit("setFormModels", filteredModels);
  } 
  props.deleteService(props.service.id);
};
</script>

<style scoped lang="scss">
.non-kvg {
  display: flex;

  .service__field {
    flex: 1;
  }
}

.service,
.model {
  position: relative;
  min-height: 80px;

  &--multiple {
    padding: 20px 50px;
    border-bottom: 1px solid var(--border-10);

    .model__name {
      color: var(--text-2);
      font-family: var(--muli-text-semi-bold);
      font-size: var(--x-small);
      margin-bottom: 15px;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  &__name {
    font-size: var(--x-small);
    color: var(--text-5);
    margin-right: 15px;
  }

  &__fields {
    display: flex;
  }

  &__field {
    width: 110px;
    margin-right: 5px;
    position: relative;

    &--economy {
      width: 180px;
    }
  }

  .policy__service-toggler {
    margin: 0;
  }
}

.models {
  border-top: 1px solid var(--border-10);
  margin-top: 15px;
}

.select--model-dropdown {
  width: 280px !important;
  margin-bottom: 20px;
}

.number-status-fields {
  margin-bottom: 20px;
  justify-content: space-between;
  //flex-wrap: wrap;
  gap: 20px;

  .service__field {
    // width: 45%;
    flex: 1;
  }
}
</style>
